export const showConfirmationModal = (payload) => async (dispatch) => {
    dispatch({ type: 'SHOW_CONFIRMATION_MODAL', payload });
};
